<template>
  <div class="email-draft">
    <p>Review the draft and send it from your email app. Nothing is sent by this website.</p>
    <div class="form-group">
      <button type="button" class="btn-default btn-large" :disabled="opening" @click="openDraft">
        Open email draft
      </button>
    </div>
    <p v-if="showValidation && draft.error" class="error-message" role="alert">{{ draft.error }}</p>
    <p v-if="openError" class="error-message" role="alert">{{ openError }}</p>
  </div>
</template>

<script>
import site from '@/data/site.json'
import { createEmailDraft } from '@/utils/emailDraft'

export default {
  name: 'EmailDraft',
  props: {
    formType: { type: String, required: true },
    values: { type: Object, required: true }
  },
  data() {
    return { showValidation: false, opening: false, openError: '' }
  },
  computed: {
    // Use current form values whenever the user opens the email client.
    draft() {
      return createEmailDraft(this.formType, this.values, site)
    }
  },
  methods: {
    openDraft() {
      if (this.opening) return
      this.showValidation = true
      this.openError = ''
      if (this.draft.error) {
        console.debug('[static-site] email-validation-failed', { site: site.brand, formType: this.formType })
        return
      }
      this.opening = true
      try {
        window.location.href = this.draft.mailto
        console.debug('[static-site] email-draft-opened', { site: site.brand, formType: this.formType })
      } catch (_) {
        this.openError = `Please open your email app and contact ${site.supportEmail}.`
        console.debug('[static-site] email-app-unavailable', { site: site.brand, formType: this.formType })
      } finally {
        this.$nextTick(() => { this.opening = false })
      }
    }
  }
}
</script>
